import { LoadState } from 'app/core/interfaces/generic.interface';
import { AuthorizationMatrix } from 'app/core/store/session/authorization/authorization.interface';
import { INITIAL_STATE_AUTHORIZATION } from 'app/core/store/session/authorization/authorization.model';
import * as customerPermissionsActions from '../customer-permissions/customer-permissions.actions';
import * as customerInfoActions from '../../customer-info/customer-info.actions';

function customerPermissionsLoad(action: customerPermissionsActions.CustomerPermissionsLoadAction, state: LoadState<AuthorizationMatrix>): LoadState<AuthorizationMatrix> {
  return {
    ...INITIAL_STATE_AUTHORIZATION,
    loading: true,
  };
}

// this action only triggered by guard that is only triggered when user is a superUser
function customerPermissionsLoadSuccess(
  action: customerPermissionsActions.CustomerPermissionsLoadSuccessAction,
  state: LoadState<AuthorizationMatrix>
): LoadState<AuthorizationMatrix> {
  const authorizationMatrix = action.payload.customerPermissions.authorizationMatrix;
  const canDoFlows = authorizationMatrix.FLOW.GET;
  const canCreateOrders = authorizationMatrix.ORDER.CREATE;
  const canCreateFlows = authorizationMatrix.FLOW.CREATE;

  return {
    ...state,
    loading: false,
    loadSuccess: true,
    loadFailed: false,
    errorMessage: null,
    data: {
      ...state.data,
      ...authorizationMatrix,
      ACCESS: {
        ...authorizationMatrix.ACCESS,
      },
      ORDER: {
        ...authorizationMatrix.ORDER,
        CREATE: canCreateOrders,
        UPDATE: canCreateOrders,
        QUERY_TEMPLATE: canCreateOrders,
      },
      FLOW: {
        ...authorizationMatrix.FLOW,
        QUERY: canDoFlows,
        CREATE: canCreateFlows,
        GET: canDoFlows,
        UPDATE: canDoFlows,
      },
    },
  };
}

function customerPermissionsLoadFail(action: customerPermissionsActions.CustomerPermissionsLoadFailAction, state: LoadState<AuthorizationMatrix>): LoadState<AuthorizationMatrix> {
  return {
    ...INITIAL_STATE_AUTHORIZATION,
    loadFailed: true,
    errorMessage: action.payload,
  };
}

function customerInfoLoadSuccess(action: customerInfoActions.CustomerInfoLoadSuccessAction, state: LoadState<AuthorizationMatrix>): LoadState<AuthorizationMatrix> {
  if (action.payload.isSuperUser) {
    return state;
  }
  const canCreateOrders = action.payload.customerInfo.orderTypes.length > 0;
  const canCreateFlows = action.payload.customerInfo.flowRegistrationTypes.length > 0;
  return {
    ...INITIAL_STATE_AUTHORIZATION,
    loadSuccess: true,
    data: {
      ...action.payload.customerInfo.authorizationMatrix,
      FLOW: {
        ...action.payload.customerInfo.authorizationMatrix.FLOW,
        CREATE: action.payload.customerInfo.authorizationMatrix.FLOW.CREATE && canCreateFlows,
        MULTI_ACCEPT: true,
      },
      ORDER: {
        ...action.payload.customerInfo.authorizationMatrix.ORDER,
        CREATE: action.payload.customerInfo.authorizationMatrix.ORDER.CREATE && canCreateOrders,
        CREATE_TEMPLATE: action.payload.customerInfo.authorizationMatrix.ORDER.CREATE_TEMPLATE && canCreateOrders,
      },
    },
  };
}

export function reducer(state = INITIAL_STATE_AUTHORIZATION, action: customerPermissionsActions.Actions | customerInfoActions.Actions): LoadState<AuthorizationMatrix> {
  let newState = state;
  switch (action.type) {
    case customerPermissionsActions.CUSTOMER_PERMISSIONS_LOAD:
      newState = customerPermissionsLoad(action, state);
      break;
    case customerPermissionsActions.CUSTOMER_PERMISSIONS_LOAD_SUCCESS:
      newState = customerPermissionsLoadSuccess(action, state);
      break;
    case customerPermissionsActions.CUSTOMER_PERMISSIONS_LOAD_FAIL:
      newState = customerPermissionsLoadFail(action, state);
      break;
    case customerInfoActions.CUSTOMER_INFO_LOAD_SUCCESS:
      newState = customerInfoLoadSuccess(action, state);
  }
  return newState;
}
